import { FunctionComponent } from "react";
import { Container } from "../../../../components/formulario/styled";
import HeaderEventos from "./header";
import TabelaListaEventos from "./tabela";

interface ContainerEventosProps {

}

const ContainerEventos: FunctionComponent<ContainerEventosProps> = () => {
  return ( <>
    <Container>
      <HeaderEventos/>
      <TabelaListaEventos />
    </Container>
  </> );
}

export default ContainerEventos;
